import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import { useNavigate } from "react-router-dom";
import logo from "lib/engleLOGO.png";
import { Button, Form, Input, Modal, Spin } from "antd";
import StyledModal from "antComponents/Modal";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [emailCode, setEmailCode] = useState(true);
  const [showTOTP, setTOTP] = useState([false, null]);
  const authState = useSelector((state) => state.mainReducer.authState);
  const loginRef = useRef(null);
  const otpRef = useRef(null);
  const [spinning, setSpinning] = useState(false)
  const [idCheckResult, setIdCheckResult] = useState([true,""])
  const [authCodeCheck, setAuthCodeCheck] = useState([true,""])
  const [otpCodeCheck, setOtpCodeCheck] = useState([true,""])
  const [passwordCheck, setPassWordCheck] = useState([true,""])
  const [count, setCount] = useState(-1) // 0으로 했을 경우 validation 문제가 있어 -1로 변경

  const backend = process.env.REACT_APP_BACKEND;

  // 인증코드의 유효성 검사를 실시한다.
  const authCodeValidator = (_, value) => {
    const regExpCode = new RegExp(/^[0-9]{6}$/);
    if (!value && authCodeCheck[0]) {
      return Promise.resolve();
    }
    if (!authCodeCheck[0]) {
      return Promise.reject(new Error(authCodeCheck[1]))
    }
    if (regExpCode.test(value) === false) {
      return Promise.reject(new Error("인증코드 형식이 맞지 않습니다."));
    }
    return Promise.resolve();
  };

  const otpCodeValidator = (_, value) => {
    const regExpCode = new RegExp(/^[0-9]{6}$/);
    if (!value && otpCodeCheck[0]) {
      return Promise.resolve();
    }
    if (!otpCodeCheck[0]) {
      return Promise.reject(new Error(otpCodeCheck[1]))
    }
    if (regExpCode.test(value) === false) {
      return Promise.reject(new Error("인증코드 형식이 맞지 않습니다."));
    }
    return Promise.resolve();
  };

  const emailValidator = () =>{
    if(idCheckResult[0] === true) {
      return Promise.resolve()
     } else {
      return Promise.reject(new Error(idCheckResult[1]))
     }
  }

  const passwordValidator = () =>{
    if(passwordCheck[0] === true) {
      return Promise.resolve()
     } else {
      return Promise.reject(new Error(passwordCheck[1]))
     }
  }

  const emailChange = () => {
    setIdCheckResult([true,""])
  }
  const authCodeChange = () => {
    setAuthCodeCheck([true,""])
  }
  const passwordChange = () => {
    setPassWordCheck([true,""])
  }

  // 이메일을 통하여 authCode를 전송받고자 하는 경우 이메일의 유효성검사 후 메일을 전송한다.
  const sendEmail = async () => {
    const emailCheck = await loginRef.current
      .validateFields(["email"])
      .then((res) => res)
      .catch((err) => err);

    if (emailCheck.email) {
      loginRef.current.resetFields(["authCode"]) // 코드 전송 버튼을 누르자마자 
      setSpinning(true)
      const email = emailCheck.email;
      await axios
        .post(`${backend}/authentication/email`, { email })
        .then((data) => {
          // loginRef.current.resetFields(["authCode"])
          setSpinning(false)
          // console.log(data.data.count)
          setCount(data.data.count-2) // 서버에서 생성되어 DB에 기록된 시간과 약 2초 정도 차이가 있음
          return Modal.success({content: data.data.message, okText:"확인"})
        })
        .catch((err) => {
          setSpinning(false)
          setIdCheckResult([false,err.response.data.message])
        });
    }
  };

  const loginRequest = (values) => {
    const { email, authCode, password } = values;

    if (authCode) {
      axios
        .post(`${backend}/authentication/email/authcode`, {
          inputAuthCode: authCode,
          email: email,
        })
        .then((data) => {
          setCount(-1)  // 인증코드가 정상적으로 인증되었다는 뜻이므로 카운팅을 종료한다.
          // email인증코드 인증 시 TOTP 진행여부에 따라 진행한다.
          if (data.data.data !== "TOTP") {
            dispatch(authAction(true, data.data.data));
            // 그대로 로그인을 완료시킨다.
            // return StyledModal.info(
            //   "이메일로그인",
            //   `${data.data.data.name}님! ${data.data.message}`
            // );
          } else {
            // TOTP 모달창을 띄워 2차 인증을 진행한다.
            setTOTP([true, "email"]);
          }
        })
        .catch((err) => {
          if(err.response.data.method === "email") {
          setIdCheckResult([false,err.response.data.message])
          } else if(err.response.data.method === "authCode") {
            setAuthCodeCheck([false,err.response.data.message])
          } else {
            return StyledModal.error("로그인 에러", err.response.data.message);
          }
        });
    } else {
      // password 인증의 경우 무조건 TOTP 모달을 띄운다.
      axios
        .post(`${backend}/authentication/email/password`, { email, password })
        .then((data) => {
          setTOTP([true, "pw"]);
        })
        .catch((err) => {
          console.log(err)
          if(err.response.data.method === "email") {
            setIdCheckResult([false,err.response.data.message])
            } else if(err.response.data.method === "password") {
              setPassWordCheck([false,err.response.data.message])
            } else {
              return StyledModal.error("로그인 에러", err.response.data.message);
            }
          // return StyledModal.error("로그인 에러", err.response.data.message);
        });
    }
  };

  // TOTP인증 시 캔슬하게 되면 인증방식에 따라서 모달창을 내리며 알림창을 띄운다.
  async function mfaHandleCancel() {
    if (showTOTP[1] === "email") {
      await StyledModal.info(
        "인증코드 알림",
        "인증코드를 이미 사용했기 때문에 재사용할 수 없게 됩니다. 인증코드를 다시 받아서 로그인을 시도하세요."
      );
    }
    otpRef.current.resetFields(['otpCode'])
    setTOTP([false, null]);
  }

  // TOTP인증을 진행한 후 최종로그인을 완료하게 된다.
  async function mfaHandleOK() {
    const otpCodeValidatorCheck = await otpRef.current
      .validateFields(["otpCode"])
      .then((res) => res)
      .catch((err) => err);

    if (otpCodeValidatorCheck.otpCode) {
      const otpCode = otpCodeValidatorCheck.otpCode;
      const email = loginRef.current.getFieldValue("email");
      await axios
        .post(`${backend}/authentication/googleTOTP/authcode`, {
          email,
          otpCode,
        })
        .then((data) => {
          setTOTP([false, null]);
          dispatch(authAction(true, data.data.data));
          // if (showTOTP[1] === "email") {
          //   dispatch(authAction(true, data.data.data));
          //   return StyledModal.info(
          //     "이메일 + 구글인증기 로그인",
          //     `${data.data.data.name}님! ${data.data.message}`
          //   ); //로그인 완료상태
          // } else if (showTOTP[1] === "pw") {
          //   dispatch(authAction(true, data.data.data));
          //   return StyledModal.info(
          //     "비밀번호 + 구글인증기 로그인",
          //     `${data.data.data.name}님! ${data.data.message}`
          //   ); //로그인 완료상태
          // }
        })
        .catch((err) => {
          setOtpCodeCheck([false,err.response.data.message])
          // return StyledModal.error("로그인에러", err.response.data.message); //인증 실패한 상태
        });
    }
  }

  const loginTest = () => {
    const id = "testID2@gmail.com";
    const userId = 3
    const userName = "테스트2"
    const userInfo = {}
    axios.post(`${backend}/test/login`, {id}).then(data=>{dispatch(authAction(true, data.data.data))}).catch(err=>alert('해지된거 같아요.'))
  };
  // const loginTest2 = () => {
  //   const id = "testID1@gmail.com";
  //   const userId = 2
  //   const userName = "테스트1"
  //   const userInfo = {}
  //   axios.post(`${backend}/test/login`, {id}).then(data=>{dispatch(authAction(true, data.data.data))}).catch(err=>alert('해지된거 같아요.'))
  // };
  // // 테스트를 위한 함수
  // const loginTest3 = () => {
    
      

  // };

  // 주소창을 통한 접근 시 로그인상태(authState)가 true라면 메인화면으로 이동시킨다.
  // useEffect(() => {
  //   if (authState === true) {
  //     navigate("/main");
  //   }
  // }, [authState, navigate]);
  useEffect(()=>{
    if(idCheckResult[0] === false) {
    loginRef.current.validateFields(["email"])
    }
    if(authCodeCheck[0] === false) {
    loginRef.current.validateFields(["authCode"])
    }
    if(passwordCheck[0] === false) {
    loginRef.current.validateFields(["password"])
    }
  },[idCheckResult,authCodeCheck, passwordCheck])

  useEffect(()=>{
    if(otpCodeCheck[0] === false) {
    otpRef.current.validateFields()
    }
  },[otpCodeCheck])

  useEffect(()=>{
    if(authState) {
      navigate('/main')
    }
  },[authState])

  useEffect(()=>{
    if(count > 0) {
      const codeTime = setInterval(()=>{
        setCount(count - 1)
      },1000)
      return () =>{clearInterval(codeTime)}
    } else if (count === 0) {
      setCount(-1)
      setAuthCodeCheck([true,""])
    }
  })

  return (
    <div style={{ display: "flex", flexDirection: "column", width:"300px"}}>
      <Modal
        open={showTOTP[0]}
        title="구글인증기"
        onOk={(e) => mfaHandleOK(e)}
        okText="확인"
        cancelText="취소"
        onCancel={mfaHandleCancel}
      >
        <Form ref={otpRef}>
          <Form.Item
            name="otpCode"
            validateTrigger={["onBlur","onChange"]}
            rules={[
              {
                required: true,
                message: "구글인증기 코드를 입력하세요.",
              },
              {
                validator: otpCodeValidator,
                validateTrigger: "onBlur"
              },
            ]}
          >
            <Input placeholder="구글인증기 인증 코드" />
          </Form.Item>
        </Form>
        <div>구글인증기에서 제시한 6자리의 숫자를 입력하세요.</div>
      </Modal>

      <Form
        ref={loginRef}
        name="loginForm"
        style={{textAlign:"left"}}
        validateTrigger={["onBlur","onChange"]}
        labelCol={{
          span: 0,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={loginRequest}
        autoComplete="off"
      >
        <img
          src={logo}
          style={{ margin: "0 0 50px 0" }}
          width="100%"
          // height="200px"
          alt="logo"
        />

        <Form.Item
          name="email"
          // label="E-mail"
          rules={[
            {
              type: "email",
              message: "이메일 주소 형식에 맞지 않습니다.",
              validateTrigger: "onBlur"
            },
            {
              required: true,
              message: "이메일 주소를 입력하세요.",
            },
            {
              validator: emailValidator
            }
          ]}
        >
          <Input id="inputEmail" placeholder="이메일 주소" onChange={emailChange} />
        </Form.Item>

        {emailCode ? (
          <Spin spinning={spinning}>
          <Form.Item
            // label="AuthCode"
            name="authCode"
            rules={[
              {
                required: true,
                message: "이메일 인증코드를 입력하세요.",
                // validateTrigger: "onChange"
              },
              {
                validator: authCodeValidator,
                validateTrigger: "onBlur"
              },
            ]}
          >
            <Input
              suffix={count > 0 ? <div style={{color:"red"}}>{count}</div> :<div onClick={sendEmail} style={{cursor:"pointer"}}>코드 전송</div>}
              placeholder="이메일 인증 코드"
              onChange={authCodeChange}
            />
          </Form.Item>
            {/* <div onClick={sendEmail} style={{cursor:"pointer"}}>코드 전송</div> */}
          </Spin>
        ) : (
          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: "비밀번호를 입력하세요.",
              },
              {
                validator: passwordValidator,
                validateTrigger: "onBlur"
              }
            ]}
          >
            <Input.Password placeholder="비밀번호" onChange={passwordChange}/>
          </Form.Item>
        )}

        <Form.Item
          wrapperCol={{
            offset: 0,
            span: 24,
          }}
        >
          <Button style={{ width: "100%" }} type="primary" htmlType="submit">
            로그인
          </Button>
        </Form.Item>
        <div onClick={() => setEmailCode(!emailCode)} style={{textAlign:"center", cursor:"pointer"}}>{emailCode ? "비밀번호로 로그인" : "인증코드로 로그인"}</div>
      </Form>
      <div style={{height:"10px"}}></div>
      <button onClick={loginTest} style={{color:"white", border:"none", background:"white", cursor:"help"}}>mfa on 테스트</button>
      {/* <button onClick={loginTest2}>mfa off 테스트</button>
      <button onClick={loginTest3}>funtion test</button> */}
      <div
        style={{
          display: "flex",
          flex: "100px",
          flexDirection: "column-reverse",
        }}
      >
        <div style={{ fontSize: "large" }}>
          마이닝을 하다보면 영어가 유창해집니다.
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
